module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAMAAACelLz8AAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAFdQTFRFAAAA////////////////////////////////////////////////////////////////////////////////////////////////////////////////jkYO6AAAAB10Uk5TAENwQhS5/7gSse2cqjboFy9rlGUKWIDA9XVuE1tS6bd4AAAAk0lEQVR4nOXR2wqDMAwG4PxQxA3F6WRs7/9sQy88DRw4mWSmIKTV+QLmJikfJW0C+hvQNQjTFhnA8rCm02RA/A36FcWfEC9KeDh3PqXvqJlT1se1plwe0KYsZ0nM1ULR6L3bNrR0by7OrS4rFwpopEd9LebSJjkrMjc85XeSPHJaHZpkvDrUeHeWkoeuqVVuxw79ALTgRhvMuPDWAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/SC.png
// module id = MDr2
// module chunks = 1